<page-container [title]="pageTitle" [border]="true" class="flex justify-center">
    <div class="grid-container">

      <div class="results-container">
        <div id="summary-results" *ngIf="displaySummary">
          <summary-table [summaryData]="smartPowerSummaryData.OverallSummary"
                        [displayLoader]="displayLoader">
          </summary-table>

          <performance-detail-table
            [tableHeader]="'Top Performing Locations'"
            [operationLocationData]="smartPowerSummaryData.OpsTopPerformer"
            [displayLoader]="displayLoader"
            [columns]="operationColumns"
            operations>
          </performance-detail-table>

          <performance-detail-table
            [tableHeader]="'Priority Locations'"
            [operationLocationData]="smartPowerSummaryData.OpsPriorityLocation"
            [displayLoader]="displayLoader"
            [columns]="operationColumns"
            operations>
          </performance-detail-table>

          <performance-detail-table
            [tableHeader]="'Food Safety Top Performers'"
            [fssLocationData]="smartPowerSummaryData.FsTopPerformer"
            [displayLoader]="displayLoader"
            [columns]="fssSafetyColumns"
            fss>
          </performance-detail-table>

          <performance-detail-table
            [tableHeader]="'Food Safety Priority Locations'"
            [fssLocationData]="smartPowerSummaryData.FsPriorityLocation"
            [displayLoader]="displayLoader"
            [columns]="fssSafetyColumns"
            fss>
          </performance-detail-table>
        </div>

        <locations-table *ngIf="!displaySummary" [data]="locationData" (sendSelect)="onLocationMetricChange($event)"></locations-table>

        <div *ngIf="displayNavigation">
          <button mat-raised-button class="smartpower-button" (click)="onSummaryClick()">SMARTPOWER Summary</button>
          <button mat-raised-button class="smartpower-button" (click)="onLocationClick()">SMARTPOWER Location Metrics</button>
        </div>

      </div>
    </div>
</page-container>
